import React from 'react';
import Styled from './ErrorPage.styled';
import { Typography, VisualIcons, Button, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import { useTranslation } from 'react-i18next';

function ErrorPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Styled.ErrorPageWrapper>
      <VisualIcons.ErrorIcon width="96" height="96" />
      <Typography component="p" variant={TYPOGRAPHY_VARIANT.BODY1}>
        {t('Common.ErrorMessage')}
      </Typography>
      <Button appearance="secondary" size="small" onClick={() => global.location.reload()}>
        {t('Common.Refresh') as string}
      </Button>
    </Styled.ErrorPageWrapper>
  );
}

export default ErrorPage;
